module.exports = __webpack_public_path__ + "static/media/pigo_5.529dc08b.png";